export const searchTooltipText = 'Search by project name and status';

export const projectProfilePath = 'project-profile';
